const STORAGE_KEY = 'ucamp_admin_push_device_id'
const SYNCED_TOKEN_KEY = 'ucamp_admin_push_synced_token'

function generateFallbackId() {
  return `app-${Date.now()}-${Math.random().toString(16).slice(2)}`
}

export function getOrCreatePushDeviceId() {
  const existing = window.localStorage.getItem(STORAGE_KEY)
  if (existing) {
    return existing
  }

  const generated = window.crypto && window.crypto.randomUUID
    ? `app-${window.crypto.randomUUID()}`
    : generateFallbackId()

  window.localStorage.setItem(STORAGE_KEY, generated)
  return generated
}

export function clearPushDeviceId() {
  window.localStorage.removeItem(STORAGE_KEY)
}

export function getLastSyncedToken() {
  return window.localStorage.getItem(SYNCED_TOKEN_KEY) || null
}

export function setLastSyncedToken(token) {
  if (token) {
    window.localStorage.setItem(SYNCED_TOKEN_KEY, token)
  } else {
    window.localStorage.removeItem(SYNCED_TOKEN_KEY)
  }
}

export function clearLastSyncedToken() {
  window.localStorage.removeItem(SYNCED_TOKEN_KEY)
}
